import React, {Component} from 'react';
import {Card} from "react-bootstrap";
import './image_card.scss';
import {TFunction} from "i18next";
import {insertHtml} from "../../../utils/dom";

interface ImageCardProps {
    title: string;
    text: string;
    image: string;
    url?: string;
    style?: any;

    cta_label?: string;
    t: TFunction;
}

class ImageCard extends Component<ImageCardProps> {
    render() {
        return (
            <Card style={ this.props.style ? this.props.style : {}}>
                    <Card.Img variant="top" src={this.props.image} alt={this.props.title} />
                    <Card.Body>
                        <Card.Title>
                            <a href={this.props.url}>{this.props.title}</a>
                        </Card.Title>
                        <Card.Text className="editor-html" {...insertHtml(this.props.text)} />
                    </Card.Body>
                    {this.props.url &&
                        <Card.Footer>
                            <Card.Link href={this.props.url}>
                                {this.props.cta_label ? this.props.cta_label : this.props.t("CA image card cta label")}
                            </Card.Link>
                        </Card.Footer>
                    }
            </Card>
        );
    }
}

export default ImageCard;